import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { TotaraMenuSection } from '../../../modules/shared/models/totara-menu.model';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false
})
export class MenuComponent {
  @Input() menuData: TotaraMenuSection[];
  @Output() toggleMenu: EventEmitter<boolean> = new EventEmitter<boolean>();

  menuSettingUrl = `${environment.totaraApi}user/quickaccessmenu.php`;
  searchUrl = `${environment.totaraApi}admin/search.php`;
  searchText = '';

  constructor(private readonly elementRef: ElementRef) {}

  @HostListener('document:click', ['$event']) onOutsideClick(event: MouseEvent): void {
    const elementItselfWasClicked: boolean = this.elementRef.nativeElement.contains(event.target);
    if (elementItselfWasClicked) {
      return;
    }
    this.toggleMenu.emit(false);
  }

  search(): void {
    window.location.href = `${this.searchUrl}?query=${this.searchText}`;
  }
}
